import { env } from "@/config/env";
import { createAxiosInstance } from "@/dataProvider/axios";
import type { AxiosInstance, AxiosResponse } from "axios";

export const AGENTIC_BASE_URL =
  process.env.NCODER_PUBLIC_DEV_AGENT_URL || `${env.API_URL}/proxy/dev-agent`;

export const AGENTIC_API_BASE_URL = `${AGENTIC_BASE_URL}/api`;

export const IS_AGENTIC_BACKEND = true;

function unwrapDataEnvelope(response: AxiosResponse): AxiosResponse {
  if (response.data && typeof response.data === "object" && "data" in response.data) {
    return {
      ...response,
      data: response.data.data,
    };
  }
  return response;
}

export function withAgenticEnvelopeUnwrap(instance: AxiosInstance): AxiosInstance {
  instance.interceptors.response.use(unwrapDataEnvelope, (error) => Promise.reject(error));
  return instance;
}

export const agenticAxios = withAgenticEnvelopeUnwrap(
  createAxiosInstance(AGENTIC_BASE_URL)
);

export const agenticApiAxios = withAgenticEnvelopeUnwrap(
  createAxiosInstance(AGENTIC_API_BASE_URL)
);
